import Route from '@ember/routing/route'

/**
 * If anything goes wrong during csv validation/import, the other routes will
 * replace the current route with this error route and pass in the rollbar uuid as
 * the queryParam to this route.
 */
export default class extends Route {
  model(params: { uuid: string }) {
    return { uuid: params.uuid }
  }
}
